module.exports = __webpack_public_path__ + "img/bc8895e.png";